
export class TargetCalculationFilterOptions {
    targetObjectAttributeIds: Array<number>;
    targetObjectIds: Array<number>;
    calculationTypeIds: Array<number>;
}
